/* NVSINO Conversion-Tracking — Seitenteil

   Meldet fachliche Ereignisse an Shopifys Ereignis-Bus (Shopify.analytics.publish).
   Von dort greift sie ein benutzerdefiniertes Web-Pixel ab und leitet sie an GA4 weiter.

   Warum dieser Umweg? Shopify lädt GA4 seit der Pixel-Umstellung in einer abgeschotteten
   Umgebung, nicht mehr auf der Seite. `window.gtag` existiert hier also nicht. Der Ereignis-Bus
   ist der vorgesehene Weg — und er berücksichtigt die Cookie-Einwilligung automatisch.

   Nutzung aus anderem Theme-Code:  window.nvsinoTrack('guide_download', { datei: '…' });
   Zum Mitlesen im Browser:         window.NVSINO_TRACKING_DEBUG = true
*/
(function () {
  var WARTESCHLANGE = [];
  var MAX_WARTEZEIT_MS = 8000;

  function bus() {
    return window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'
      ? window.Shopify.analytics.publish
      : null;
  }

  function senden(name, daten) {
    var publish = bus();
    if (!publish) return false;
    try {
      publish(name, daten);
      if (window.NVSINO_TRACKING_DEBUG) console.log('[nvsino-tracking]', name, daten);
    } catch (e) {
      if (window.NVSINO_TRACKING_DEBUG) console.warn('[nvsino-tracking] Fehler', e);
    }
    return true;
  }

  window.nvsinoTrack = function (name, daten) {
    if (!name) return;
    var basis = {};
    try {
      basis.seite = window.location.pathname;
      basis.sprache = (document.documentElement.lang || '').slice(0, 2) || 'de';
    } catch (e) {}
    for (var k in daten) if (Object.prototype.hasOwnProperty.call(daten, k)) basis[k] = daten[k];
    if (!senden(name, basis)) WARTESCHLANGE.push([name, basis]);
  };

  // Der Ereignis-Bus steht erst nach dem Laden bereit — Warteschlange nachziehen
  var start = Date.now();
  var timer = setInterval(function () {
    if (bus()) {
      while (WARTESCHLANGE.length) {
        var e = WARTESCHLANGE.shift();
        senden(e[0], e[1]);
      }
      clearInterval(timer);
    } else if (Date.now() - start > MAX_WARTEZEIT_MS) {
      clearInterval(timer);
      WARTESCHLANGE.length = 0;
    }
  }, 300);

  // ---------- Ereignisse, die sich zentral abgreifen lassen ----------
  document.addEventListener('DOMContentLoaded', function () {

    // Newsletter- und Konto-Anmeldungen (Shopify-Kundenformulare)
    document.querySelectorAll('form[action*="/contact"], form[action*="/account"]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var ziel = f.action || '';
        var art = ziel.indexOf('/account/register') > -1 ? 'community_signup'
                : ziel.indexOf('/account/login') > -1 ? 'community_login'
                : 'newsletter_signup';
        window.nvsinoTrack(art, { formular: f.id || 'unbenannt' });
      });
    });

    // FAQ-Stichwortsuche: erst nach Tippende melden, sonst je Tastendruck ein Ereignis
    var faqTimer = null;
    document.querySelectorAll('input[placeholder*="Stichwort"], input[placeholder*="keyword"]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        clearTimeout(faqTimer);
        faqTimer = setTimeout(function () {
          var begriff = (inp.value || '').trim();
          if (begriff.length < 3) return;
          var sichtbar = 0;
          try {
            sichtbar = [].slice.call(document.querySelectorAll('main details'))
                        .filter(function (d) { return d.offsetParent !== null; }).length;
          } catch (e) {}
          window.nvsinoTrack('faq_suche', { suchbegriff: begriff.toLowerCase().slice(0, 60), treffer: sichtbar });
        }, 1200);
      });
    });
  });
})();
